export default "__VITE_ASSET__CoYch570__"